import { useAuth } from '@/app/hooks/useAuth'
import { Outlet } from 'react-router-dom'

export const CustomerLayout = () => {
  const { isAdmin } = useAuth()

  if (!isAdmin) return <Outlet />

  return (
    <div className="flex min-h-full w-full flex-1 justify-between gap-8">
      <div className="w-full">
        <Outlet />
      </div>
    </div>
  )
}
